
export const OPEN_CONTACT = "OPEN_CONTACT";
export const SET_MENU = "SET_MENU";
export const ERROR_CONTROL = "ERROR_CONTROL";
export const LOADER = " LOADER";
export const RESET_ALL = "RESET_ALL";
